// Fonction pour générer les labels de date dynamiques
export const generateDateLabels = () => {
    const currentDate = new Date();

    // Fonction utilitaire pour formater le mois/année
    const formatMonthYear = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);

        return { month, year };
    };

    // Fonction pour ajouter des mois à une date
    const addMonths = (date, months) => {
        const newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() + months);

        return newDate;
    };

    // Fonction pour créer une plage de dates avec format optimisé
    const getDateRange = (startMonths, endMonths) => {
        const startDate = addMonths(currentDate, startMonths);
        const endDate = addMonths(currentDate, endMonths);

        const start = formatMonthYear(startDate);
        const end = formatMonthYear(endDate);

        // Si les années sont identiques, n'afficher l'année qu'une seule fois
        if (start.year === end.year) {
            return `${start.month}-${end.month}/${start.year}`;
        }
        else {
            return `${start.month}/${start.year}-${end.month}/${end.year}`;
        }
    };

    // Dates individuelles
    const currentMonth = formatMonthYear(currentDate);
    const nextMonth = formatMonthYear(addMonths(currentDate, 1));
    const nextTwoMonth = formatMonthYear(addMonths(currentDate, 2));

    return {
        currentMonthLabel: `${currentMonth.month}/${currentMonth.year}`,
        nextMonthLabel: `${nextMonth.month}/${nextMonth.year}`,
        nextTwoMonthLabel: `${nextTwoMonth.month}/${nextTwoMonth.year}`,
        trimesterLabel: getDateRange(3, 5),
        semesterLabel: getDateRange(6, 11)
    };
};